import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/Home';
import OurTeam from './pages/OurTeam';
import HealthAdvisory from './pages/HealthAdvisory';
import OnyxLabs from './pages/OnyxLabs';
import GovernmentContracts from './pages/GovernmentContracts';
import News from './pages/News';
import Insights from './pages/Insights';
import InsightsArticle from './pages/InsightsArticle';
import Schedule from './pages/Schedule';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/health-advisory" element={<HealthAdvisory />} />
          <Route path="/onyx-labs" element={<OnyxLabs />} />
          <Route path="/government-contracts" element={<GovernmentContracts />} />
          <Route path="/news" element={<News />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightsArticle />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
